import { NODE_TYPE_LINK, NODE_TYPE_SUBSTANCE } from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteTreeView/constants';
import { isItemRPSCompound, updateItemRPSCompound, updateGroupRPSCompound } from './RPSUtils';
import { trimUptoTwoDecimals } from '../../utils';

// eslint-disable-next-line import/prefer-default-export,default-param-last
export const buildTreeFromList = (items = [], isGroup, id, parentStepNumber) => {
  return items
    .filter((item) => (isGroup ? item.group === id : item.parentId === id))
    .map((item) => {
      const prependLink = !item.leafNode;
      const _data = { ...item, parentStepNumber };
      _data.confidence = trimUptoTwoDecimals(_data.confidence);

      let children;
      if (item.groups) {
        children = item.groups.map((group) => {
          return {
            _type: NODE_TYPE_LINK,
            _data: {
              ..._data,
              group: group.id,
              step: group.id,
              yield: group.yield,
              custom: group.custom,
              type: group.type,
              confidence: trimUptoTwoDecimals(group.confidence),
              reaction: {
                ..._data.reaction,
                reactionId: group.reactionId,
                databaseId: group.databaseId,
              },
              multiStep: group.multiStep,
              multiStepEnrolled: group.multiStepEnrolled,
              // RPS - update group data if item is RPS compound
              // updateGroupRPSCompound returns only { type, reactionId, databaseId }
              ...(isItemRPSCompound(item) && updateGroupRPSCompound(group, items)),
            },
            children: buildTreeFromList(items, true, group.id, item.step),
          };
        });
      } else if (prependLink) {
        children = [
          {
            _type: NODE_TYPE_LINK,
            // RPS - update link data if item is RPS compound
            // updateItemRPSCompound returns only { type, reaction: { reactionId, databaseId } }
            _data: isItemRPSCompound(item) ? { ..._data, ...updateItemRPSCompound(_data) } : _data,
            children: buildTreeFromList(items, false, item.id, item.step),
          },
        ];
      } else {
        children = buildTreeFromList(items, false, item.id, item.step);
      }

      return {
        _type: NODE_TYPE_SUBSTANCE,
        _data,
        children,
      };
    });
};
